export interface AddressCityData {
  name?: string | null;
  state?: { code?: string | null } | null;
}

export interface AddressData {
  street?: string | null;
  number?: string | null;
  neighborhood?: string | null;
  city?: AddressCityData | null;
  is_primary?: boolean | null;
  deleted_at?: string | null;
}

/**
 * Primary (or first non-deleted) address from a list. Mirrors the pattern already
 * used for owners elsewhere in the app (src/lib/appointments/owner-address.ts),
 * duplicated here because print-core is shared between the browser client and the
 * PDF Lambda (Node) and can't import from src/.
 */
export function pickPrimaryAddress<T extends AddressData>(
  addresses: T[] | null | undefined,
): T | null {
  const active = (addresses ?? []).filter((address) => !address?.deleted_at);
  return active.find((a) => a?.is_primary) ?? active[0] ?? null;
}

/** Formats "Rua X, 123 - Bairro, Cidade/UF"; empty string when there's nothing to show. */
export function formatAddressLine(address: AddressData | null): string {
  if (!address) return "";

  const streetLine = [address.street?.trim(), address.number?.trim()]
    .filter(Boolean)
    .join(", ");
  const cityState = [address.city?.name?.trim(), address.city?.state?.code?.trim()]
    .filter(Boolean)
    .join("/");
  const locality = [address.neighborhood?.trim(), cityState].filter(Boolean).join(", ");

  return [streetLine, locality].filter(Boolean).join(" - ");
}
